import { render, staticRenderFns } from "./Publisher.vue?vue&type=template&id=3b153e5b&scoped=true&"
import script from "./Publisher.vue?vue&type=script&lang=js&"
export * from "./Publisher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b153e5b",
  null
  
)

export default component.exports